import { useCallback } from 'react';
import { useSearchParams } from 'react-router';

/**
 * URL query parameters as page state. Empty values are removed; any change
 * other than "page" resets pagination to the first page.
 */
export function useUrlState() {
  const [params, setParams] = useSearchParams();
  const update = useCallback(
    (patch: Record<string, string>) => {
      setParams(
        (prev) => {
          const next = new URLSearchParams(prev);
          for (const [k, v] of Object.entries(patch)) {
            if (v) next.set(k, v);
            else next.delete(k);
          }
          if (!('page' in patch)) next.delete('page');
          return next;
        },
        { replace: true },
      );
    },
    [setParams],
  );
  return [params, update] as const;
}
